import { c as e } from "../../../../index.esm-BeDSGXP5.js";
import { css as i } from "styled-components";
const a = {
  base: ({ theme: l }) => /* @__PURE__ */ i([
    "",
    " ",
    " box-sizing:border-box;text-decoration:none;"
  ], l.resets.space, e({
    fontFamily: "heading",
    color: l.componentColors.heading.default
  })),
  huge: () => /* @__PURE__ */ i([
    "",
    ""
  ], e({
    fontSize: [
      "headingHugeMobile",
      null,
      "headingHugeDesktop"
    ],
    fontWeight: "bold",
    lineHeight: [
      "headingHugeMobile",
      null,
      "headingHugeDesktop"
    ],
    paddingBottom: "sm"
  })),
  large: () => /* @__PURE__ */ i([
    "",
    ""
  ], e({
    fontSize: [
      "headingLargeMobile",
      null,
      "headingLargeDesktop"
    ],
    fontWeight: "bold",
    lineHeight: [
      "headingLargeMobile",
      null,
      "headingLargeDesktop"
    ],
    paddingBottom: "sm"
  })),
  medium: () => /* @__PURE__ */ i([
    "",
    ""
  ], e({
    fontSize: [
      "headingMediumMobile",
      null,
      "headingMediumDesktop"
    ],
    fontWeight: "semiBold",
    lineHeight: [
      "headingMediumMobile",
      null,
      "headingMediumDesktop"
    ],
    paddingBottom: "xs"
  })),
  small: () => /* @__PURE__ */ i([
    "",
    ""
  ], e({
    fontSize: [
      "headingSmallMobile",
      null,
      "headingSmallDesktop"
    ],
    fontWeight: "semiBold",
    lineHeight: [
      "headingSmallMobile",
      null,
      "headingSmallDesktop"
    ],
    paddingBottom: "xs"
  })),
  xSmall: () => /* @__PURE__ */ i([
    "",
    ""
  ], e({
    fontFamily: "body",
    fontSize: [
      "headingXsmallMobile",
      null,
      "headingXsmallDesktop"
    ],
    fontWeight: "regular",
    lineHeight: [
      "headingXsmallMobile",
      null,
      "headingXsmallDesktop"
    ],
    paddingBottom: "xs"
  }))
};
export {
  a as default
};
